import { FC, useContext } from "react";
import { ChatMessage } from "../../../../common/store/chat/types/chat-message";
import { BotChatMessage } from "./bot-chat-message";
import { ChatContext } from "../../../contexts/chat-context";
import { UserChatMessage } from "./user-chat-message";
import OperatorChatMessage from "./operator-chat-message";

type Props = {
  message: ChatMessage;
  index: number;
}

const MessageParser: FC<Props> = ({message, index}) => {
  const { lastMessage } = useContext(ChatContext);
  if (!message.value) {
    return null;
  }

  switch (message.itemType) {
    case 'A':
    case 'live_agent':
      return (
        <BotChatMessage
          message={message}
          index={index}
          isLastMessage={
            message.itemType === 'A'
              ? lastMessage?.typeA.turn_id === message.turn_id
              : lastMessage?.typeAgent.turn_id === message.turn_id
          }
        />
      );
    case 'U':
      return <UserChatMessage isLastMessage={lastMessage?.typeU.turn_id === message.turn_id} message={message} />
    case 'operator':
      return <OperatorChatMessage value={message.value} />
    default:
      return null;
  }
}

export default MessageParser;
